import React, { FC, ReactElement } from 'react';
import { styled } from '@cherre-frontend/ui';

const UpdateContent = styled('p')`
  margin: 0px;
  color: #ff9b04;
  font-family: Montserrat;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
`;
const ConnectorCardUpdateAvailableText: FC = (): ReactElement => (
  <UpdateContent>Update Available!</UpdateContent>
);

export default ConnectorCardUpdateAvailableText;
